import Model from "./base/model";

class VehicleTypeModal extends Model {
  resourceName() {
    return "vehicle_type_modal";
  }

  fields() {
    return {
      vehicle_type_id: "",
      modal: "",
      vehicle_type: {jsonApi: "hasMany", type: "vehicle_types"},
    };
  }
}

export default new VehicleTypeModal();
